// represents the minimal int->int edge
export class IntPair {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    get source() {
        return this.x;
    }
    get target() {
        return this.y;
    }
    isDiagonal() {
        return this.x === this.y;
    }
}
//# sourceMappingURL=IntPair.js.map